import { validatePresence, validateLength, validateFormat } from 'ember-changeset-validations/validators'

const defaultValidation = {
  firstName: [
    validatePresence({ presence: true, ignoreBlank: true }),
    validateFormat({
      // fail on "Student First Name (Enter Here)" (the value from the sample CSV, to ensure they change it)
      regex: /Student First Name \(Enter Here\)/g,
      inverse: true,
    }),
  ],
  lastName: [
    validatePresence({ presence: true, ignoreBlank: true }),
    validateFormat({
      // fail on "Student Last Name (Enter Here)" (the value from the sample CSV, to ensure they change it)
      regex: /Student Last Name \(Enter Here\)/g,
      inverse: true,
    }),
  ],
  gradePosition: [validatePresence(true)],
}

export default defaultValidation

export const editStudentValidator = {
  ...defaultValidation,
  plainPassword: [
    validatePresence(true),
    validateLength({ min: 4 }),
    validateFormat({
      // blocks password from containing `~!#$%^*()|=[]{}/\'<,>?";: and space
      regex: /`|~|!|#|\$|%|\^|&|\*|\(|\)|\|=|\[|\{|\]|\}|\||\\|'|<|,|>|\?|\/|""|;|:|\s/g,
      inverse: true,
    }),
  ],
  login: [
    validatePresence(true),
    validateLength({ min: 3 }),
    validateFormat({ regex: /^[\p{L}\p{M}\p{N}+@._'-]{3,}$/u }),
  ],
}
